import React from "react";

const ContactResponse = () => {
  React.useEffect(() => {
    let popup = document.querySelector(".contact_popup_container");
    let popUpCloseBtn = document.querySelector("#contact_popup_close");
    popUpCloseBtn.onclick = function () {
      popup.classList.remove("active");
      window.location = document.URL;
    };
  });

  return (
    <aside
      id="contact_popup"
      className="contact_popup_container"
      aria-label="popup"
    >
      <div className="popup">
        <h2>
          Thank you for contacting us. We will get in touch with you soon.
        </h2>
        <div className="form__fields">
          <button
            className="btn btn__primary"
            type="button"
            id="contact_popup_close"
          >
            <div className="btn__text">CLOSE</div>
          </button>
        </div>
      </div>
    </aside>
  );
};
export default ContactResponse;
